import { useEffect, useState } from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";

// Initialization happens once per page, so mounts after the first wait no longer.
let hasInitialized = false;

/**
 * Returns true once LaunchDarkly has initialized. FeatureFlagLoader renders
 * before that, so useFlags() returns defaults until then. A failed or timed-out
 * initialization also counts as ready, so flags settle to their defaults.
 */
export function useLaunchDarklyReady(): boolean {
  const ldClient = useLDClient();
  const [isReady, setIsReady] = useState(hasInitialized);
  useEffect(() => {
    if (!ldClient || isReady) return;
    let isCanceled = false;
    ldClient
      .waitForInitialization(5)
      .catch(() => undefined)
      .then(() => {
        hasInitialized = true;
        if (!isCanceled) setIsReady(true);
      });
    return () => {
      isCanceled = true;
    };
  }, [ldClient, isReady]);
  return isReady;
}
